import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/system-button/system-button.js';
      import {SystemState, SystemButtonVariant, ActivePanel} from '@oicl/openbridge-webcomponents/dist/components/system-button/system-button.js';

      export interface Props {
     variant?: SystemButtonVariant;
     disabled?: boolean;
     systemState?: SystemState;
     menuOpen?: boolean;
     activePanel?: ActivePanel | null
   }

      
  
      export type {SystemState, SystemButtonVariant, ActivePanel} from '@oicl/openbridge-webcomponents/dist/components/system-button/system-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSystemButton',
  props: {
    variant: {},
    disabled: { type: Boolean },
    systemState: {},
    menuOpen: { type: Boolean },
    activePanel: {}
  },
  emits: ["menu-toggle", "system-state-change", "microphone-panel-open", "volume-panel-open", "system-icons-panel-open"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onMenuToggle: (event: CustomEvent<{open: boolean}>) => emit('menu-toggle', event as CustomEvent<{open: boolean}>),
onSystemStateChange: (event: CustomEvent<{state: SystemState}>) => emit('system-state-change', event as CustomEvent<{state: SystemState}>),
onMicrophonePanelOpen: (event: CustomEvent<void>) => emit('microphone-panel-open', event as CustomEvent<void>),
onVolumePanelOpen: (event: CustomEvent<void>) => emit('volume-panel-open', event as CustomEvent<void>),
onSystemIconsPanelOpen: (event: CustomEvent<void>) => emit('system-icons-panel-open', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-system-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})